import React, { Component } from 'react';
import { Nav } from 'react-bootstrap';
import NavItem from 'react-bootstrap/es/NavItem';
import Icon from '../../../../common/components/Icon/Icon';

export default class GuestNavigation extends Component {
  render() {
    return (
      <div>
        <Nav className="guest-nav">
          <NavItem eventKey={9}>
            <Icon name="home" />
          </NavItem>
          {/*  </LinkContainer>
          <LinkContainer to="/contact">
            <NavItem eventKey={8}>Contact Us</NavItem>
          </LinkContainer>
          <LinkContainer to="/cookies">
            <NavItem eventKey={7}>Cookies</NavItem>
          </LinkContainer>
          <LinkContainer to="/privacy">
            <NavItem eventKey={7}>Privacy</NavItem>
          </LinkContainer>*/}
        </Nav>
      </div>
    );
  }
}
